import { Dialog, type DialogProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import * as tkn from './Modal.tokens'
import type { ModalSize, ModalProps } from './Modal.types'

/** Fill modals sit on an 8px gutter per side instead of MUI's default 32px dialog margin. */
export const FILL_GUTTER = '8px'
export const FILL_WIDTH = 'calc(100% - 16px)'

/**
 * `xxl` and `upsell` have no design-system token: `xxl` fills the viewport, `upsell` is bespoke.
 */
export const MODAL_SIZES: Record<ModalSize, string> = {
  s: tkn.ModalSizeWidthSmall,
  m: tkn.ModalSizeWidthMedium,
  l: tkn.ModalSizeWidthLarge,
  xl: tkn.ModalSizeWidthXlarge,
  xxl: FILL_WIDTH,
  upsell: '886px',
}

interface StyledModalProps extends DialogProps {
  placement?: ModalProps['placement']
}

export const Modal = styled(Dialog, {
  shouldForwardProp: youShallNotPass('placement', 'size'),
})<StyledModalProps>(({ placement, theme }) => ({
  zIndex: theme.zIndexes.dialog,
  '& .MuiBackdrop-root': {
    background: 'rgba(0, 0, 0, 0.3)',
  },
  '& .MuiDialog-container': {
    ...(placement === 'top' && {
      alignItems: 'flex-start',
    }),
  },
}))
